import { z } from 'zod';
import type { CardDto } from '../types/CardDto';

export const cardDtoSchema = z.object({
  id: z.string().uuid(),
  type: z.enum(['video', 'image', 'text', 'textAndImage', 'quiz', 'redirect']),
  title: z.string().min(3).max(255),
  isActive: z.boolean().default(false).optional(),
  content: z.string().nullable(),
  contentDetails: z.string().nullable(),
  contentImage: z.string().nullable(),
  position: z.number().int().min(1),
  creatorId: z.string().uuid(),
  courseId: z.string().uuid(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  deletedAt: z.string().datetime({ offset: true }).nullable(),
}) as z.ZodType<CardDto>;
